export type StripeIntentRequiresAction = {
  intentId: string;
  clientSecret: string;
};

const getGraphqlErrorException = (error: unknown): Record<string, unknown> | null => {
  const apolloError = error as {
    graphQLErrors?: Array<{ extensions?: { exception?: Record<string, unknown> } }>;
    networkError?: { result?: { errors?: Array<{ extensions?: { exception?: Record<string, unknown> } }> } };
  };

  return (
    apolloError.graphQLErrors?.[0]?.extensions?.exception ?? apolloError.networkError?.result?.errors?.[0]?.extensions?.exception ?? null
  );
};

const parseRequiresAction = (intentId: unknown, clientSecret: unknown): StripeIntentRequiresAction | null => {
  if (typeof intentId !== 'string' || typeof clientSecret !== 'string') {
    return null;
  }

  return { intentId, clientSecret };
};

export const getStripeIntentRequiresActionFromGraphqlError = (error: unknown): StripeIntentRequiresAction | null => {
  const exception = getGraphqlErrorException(error);
  if (!exception?.code) {
    return null;
  }

  if (exception.code === 'setupIntentRequiresAction') {
    return parseRequiresAction(exception.setupIntentId, exception.setupIntentClientSecret);
  }

  if (exception.code === 'paymentIntentRequiresAction') {
    return parseRequiresAction(exception.paymentIntentId, exception.paymentIntentClientSecret);
  }

  return null;
};
